import Box from '@mui/material/Box';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { useTranslation } from 'react-i18next';
import {
  DetailGrid,
  DetailHeader,
  DetailPage,
  DetailRow,
  DetailSection,
} from '../../../../components/ui/detailView';
import { StatusChip } from '../../../../components/ui/statusChip/statusChip.component';
import { useAuthContext } from '../../../../contexts/auth';
import { formatDate } from '../../../../utils';
import { countryName } from '../../../../utils/countries';

export const TenantBasicInfo = () => {
  const { t } = useTranslation();
  const { currentUser, currentUserLoading } = useAuthContext();
  const tenant = currentUser?.tenant;

  if (currentUserLoading || !tenant) {
    return <DetailPage loading />;
  }

  const stateLabel = tenant.is_active ? t('Active') : t('Inactive');

  return (
    <DetailPage>
      <DetailHeader
        icon={
          tenant.logo ? (
            <Box
              component="img"
              src={tenant.logo}
              alt={t('Company logo')}
              sx={{ width: '100%', height: '100%', objectFit: 'contain', bgcolor: 'background.paper' }}
            />
          ) : (
            <ApartmentOutlinedIcon />
          )
        }
        title={tenant.name}
        subtitle={tenant.website}
        chips={<StatusChip label={stateLabel} color={tenant.is_active ? 'success' : 'warning'} />}
      />

      <DetailGrid>
        <DetailSection title={t('Workspace')}>
          {!tenant.is_active && (
            <DetailRow
              label={t('Scheduled termination date')}
              value={tenant.termination_date ? formatDate(tenant.termination_date) : t('Not scheduled')}
            />
          )}
          <DetailRow label={t('Name')} value={tenant.name} />
          <DetailRow label={t('Website')} value={tenant.website} />
          <DetailRow
            label={t('Logo')}
            value={
              tenant.logo && (
                <Box
                  component="img"
                  src={tenant.logo}
                  alt={t('Company logo')}
                  sx={{
                    display: 'block',
                    maxWidth: '180px',
                    maxHeight: '64px',
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain',
                  }}
                />
              )
            }
          />
        </DetailSection>

        <DetailSection title={t('Company registration')}>
          <DetailRow label={t('NIP')} value={tenant.nip} />
          <DetailRow label={t('REGON')} value={tenant.regon} />
          <DetailRow label={t('KRS')} value={tenant.krs} />
          <DetailRow label={t('PESEL')} value={tenant.pesel} />
          <DetailRow
            label={t('Company address')}
            value={[tenant.street, [tenant.zip_code, tenant.city].filter(Boolean).join(' '), countryName(tenant.country)]
              .filter(Boolean)
              .join(', ')}
          />
        </DetailSection>
      </DetailGrid>
    </DetailPage>
  );
};
